/* Rose Winery — theme behaviours (header, mega-menu, drawer, scroll reveal) */
(function () {
  function initHeader() {
    var header = document.querySelector(".site-header");
    if (!header || header.dataset.bound === "1") return;
    header.dataset.bound = "1";

    var alwaysSolid = header.getAttribute("data-always-solid") === "true";
    function onScroll() {
      header.classList.toggle("solid", alwaysSolid || window.scrollY > 40);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    /* Desktop mega-menu (hover) */
    var items = header.querySelectorAll(".nav-item[data-panel]");
    var panels = header.querySelectorAll(".mega");
    function closePanels() {
      panels.forEach(function (p) {
        p.classList.remove("open");
      });
      header.classList.remove("menu-open");
      header.querySelectorAll(".nav-link").forEach(function (l) {
        l.classList.remove("active");
      });
    }
    items.forEach(function (item) {
      item.addEventListener("mouseenter", function () {
        closePanels();
        var id = item.getAttribute("data-panel");
        var panel = header.querySelector('.mega[data-panel="' + id + '"]');
        if (panel) {
          panel.classList.add("open");
          header.classList.add("menu-open");
          var link = item.querySelector(".nav-link");
          if (link) link.classList.add("active");
        }
      });
    });
    header.addEventListener("mouseleave", closePanels);

    /* Mobile drawer */
    var burger = header.querySelector(".burger");
    var drawer = document.querySelector(".drawer");
    var drawerClose = document.querySelector(".drawer-close");
    function openDrawer() {
      if (drawer) {
        drawer.classList.add("open");
        document.body.style.overflow = "hidden";
      }
    }
    function closeDrawer() {
      if (drawer) {
        drawer.classList.remove("open");
        document.body.style.overflow = "";
      }
    }
    if (burger) burger.addEventListener("click", openDrawer);
    if (drawerClose) drawerClose.addEventListener("click", closeDrawer);
    if (drawer)
      drawer.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", closeDrawer);
      });
  }

  function initReveal(scope) {
    var root = scope || document;
    var reveals = root.querySelectorAll(".reveal:not(.in)");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      reveals.forEach(function (el) {
        el.classList.add("in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Cart (AJAX + slide-in drawer) ---- */
  function cartCounts(n) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      el.textContent = n;
      if (n > 0) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });
  }
  function openCart() {
    var d = document.getElementById("cart-drawer");
    if (d) {
      d.classList.add("open");
      document.body.style.overflow = "hidden";
    }
  }
  function closeCart() {
    var d = document.getElementById("cart-drawer");
    if (d) {
      d.classList.remove("open");
      document.body.style.overflow = "";
    }
  }
  function applyCartSection(sections) {
    if (!sections || !sections["cart-drawer"]) return;
    var doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
    var fresh = doc.querySelector("[data-cart-contents]");
    var cur = document.querySelector("#cart-drawer [data-cart-contents]");
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function refreshCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        cartCounts(c.item_count);
      });
  }
  function cartAdd(form) {
    var fd = new FormData(form);
    fd.append("sections", "cart-drawer");
    fd.append("sections_url", window.location.pathname);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute("disabled", "");
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: fd })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) {
          if (btn) btn.removeAttribute("disabled");
          return;
        }
        applyCartSection(data.sections);
        return refreshCount();
      })
      .then(function () {
        if (btn) btn.removeAttribute("disabled");
        if (document.body.classList.contains("template-cart")) {
          window.location.reload();
          return;
        }
        openCart();
      })
      .catch(function () {
        if (btn) btn.removeAttribute("disabled");
      });
  }
  function cartChange(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        line: line,
        quantity: qty,
        sections: ["cart-drawer"],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartCounts(cart.item_count);
        applyCartSection(cart.sections);
      });
  }
  function initCart() {
    if (document.body.dataset.cartBound === "1") return;
    document.body.dataset.cartBound = "1";

    document.addEventListener("change", function (e) {
      var permit = e.target.closest("[data-cart-permit]");
      if (!permit) return;
      var value = permit.checked ? "Ja" : "";
      document.querySelectorAll("[data-cart-permit]").forEach(function (box) {
        box.checked = permit.checked;
      });
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "Må stilles ved døren": value } }),
      });
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-open]")) {
        e.preventDefault();
        openCart();
        return;
      }
      var closer = e.target.closest("[data-cart-close]");
      if (closer) {
        var isLink = closer.tagName === "A" && closer.getAttribute("href");
        if (!isLink) e.preventDefault();
        closeCart();
        return;
      }
      var line = e.target.closest(".cart-line");
      if (line) {
        var idx = parseInt(line.getAttribute("data-line"), 10);
        var qtyEl = line.querySelector(".cart-qty span");
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest("[data-qty-up]")) {
          e.preventDefault();
          cartChange(idx, qty + 1);
        } else if (e.target.closest("[data-qty-down]")) {
          e.preventDefault();
          cartChange(idx, qty - 1);
        } else if (e.target.closest("[data-qty-remove]")) {
          e.preventDefault();
          cartChange(idx, 0);
        }
      }
    });

    document.addEventListener("submit", function (e) {
      if (e.target.matches && e.target.matches('form[action$="/cart/add"]')) {
        e.preventDefault();
        cartAdd(e.target);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCart();
    });
  }

  function initCountry() {
    document.querySelectorAll("select[data-default]").forEach(function (s) {
      if (s.dataset.default) s.value = s.dataset.default;
    });
  }
  function initProduct() {
    document.addEventListener("click", function (e) {
      var step = e.target.closest("[data-qty-minus], [data-qty-plus]");
      if (step) {
        var wrap = step.closest("[data-qty]");
        var input = wrap && wrap.querySelector(".qty-input");
        if (input) {
          var v = parseInt(input.value, 10) || 1;
          v = step.hasAttribute("data-qty-plus") ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        }
        return;
      }
      var setBtn = e.target.closest("[data-qty-set]");
      if (setBtn) {
        var form = setBtn.closest("form");
        var qi = form && form.querySelector(".qty-input");
        if (qi) qi.value = setBtn.getAttribute("data-qty-set");
        var sub = form && form.querySelector('[type="submit"]');
        if (sub) sub.click();
      }
    });
  }
  function caseAdd(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items, sections: ["cart-drawer"], sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyCartSection(data.sections); return refreshCount(); })
      .then(function () {
        if (document.body.classList.contains("template-cart")) { window.location.reload(); return; }
        openCart();
      });
  }
  function initBuildCase() {
    var root = document.querySelector("[data-build-case]");
    if (!root) return;
    var bar = root.querySelector("[data-case-bar]");
    var totalQtyEl = root.querySelector("[data-case-total-qty]");
    var totalPriceEl = root.querySelector("[data-case-total-price]");
    var addBtn = root.querySelector("[data-case-add]");
    function money(cents) {
      return (cents / 100).toLocaleString("da-DK", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " kr";
    }
    function recalc() {
      var qty = 0, price = 0;
      root.querySelectorAll("[data-case-item]").forEach(function (it) {
        var c = parseInt(it.querySelector("[data-case-count]").textContent, 10) || 0;
        qty += c;
        price += c * (parseInt(it.getAttribute("data-price"), 10) || 0);
        it.classList.toggle("selected", c > 0);
      });
      if (totalQtyEl) totalQtyEl.textContent = qty;
      if (totalPriceEl) totalPriceEl.textContent = qty > 0 ? money(price) : "";
      if (bar) { if (qty > 0) bar.removeAttribute("hidden"); else bar.setAttribute("hidden", ""); }
      var target = parseInt(root.getAttribute("data-target"), 10) || 0;
      var fill = root.querySelector("[data-case-progress]");
      if (fill && target) fill.style.width = Math.min(100, (qty / target) * 100) + "%";
      var check = root.querySelector("[data-case-check]");
      if (check) {
        if (target && qty >= target) check.removeAttribute("hidden");
        else check.setAttribute("hidden", "");
      }
    }
    root.addEventListener("click", function (e) {
      var item = e.target.closest("[data-case-item]");
      if (item) {
        var countEl = item.querySelector("[data-case-count]");
        var c = parseInt(countEl.textContent, 10) || 0;
        if (e.target.closest("[data-case-plus]")) { countEl.textContent = c + 1; recalc(); return; }
        if (e.target.closest("[data-case-minus]")) { countEl.textContent = Math.max(0, c - 1); recalc(); return; }
      }
      if (e.target.closest("[data-case-add]")) {
        var items = [];
        root.querySelectorAll("[data-case-item]").forEach(function (it) {
          var c = parseInt(it.querySelector("[data-case-count]").textContent, 10) || 0;
          if (c > 0) items.push({ id: it.getAttribute("data-variant"), quantity: c });
        });
        if (!items.length) return;
        if (addBtn) addBtn.setAttribute("disabled", "");
        caseAdd(items).then(function () { if (addBtn) addBtn.removeAttribute("disabled"); });
      }
    });
  }
  function initSearch() {
    var pop = document.querySelector("[data-search-pop]");
    if (!pop) return;
    var input = pop.querySelector("[data-search-input]");
    var results = pop.querySelector("[data-search-results]");
    var searchUrl = pop.getAttribute("data-search-url") || "/search";
    function openPop() {
      pop.removeAttribute("hidden");
      requestAnimationFrame(function () { pop.classList.add("in"); });
      document.body.style.overflow = "hidden";
      setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function closePop() {
      pop.classList.remove("in");
      document.body.style.overflow = "";
      setTimeout(function () { pop.setAttribute("hidden", ""); }, 300);
    }
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-search-open]");
      if (t) { e.preventDefault(); openPop(); return; }
      if (e.target.closest("[data-search-close]")) { e.preventDefault(); closePop(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !pop.hasAttribute("hidden")) closePop();
    });
    if (!input || !results) return;
    var suggest = pop.querySelector("[data-search-suggest]");
    pop.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-search-term]");
      if (chip) {
        input.value = chip.getAttribute("data-search-term");
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.focus();
      }
    });
    function esc(s) {
      var d = document.createElement("div");
      d.textContent = s;
      return d.innerHTML;
    }
    function money(p) {
      var n = parseFloat(p);
      return isNaN(n) ? p : n.toLocaleString("da-DK", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " kr";
    }
    function thumb(u) {
      return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=120";
    }
    function render(html) {
      if (html) { results.innerHTML = html; results.removeAttribute("hidden"); }
      else { results.innerHTML = ""; results.setAttribute("hidden", ""); }
      if (suggest) {
        if (html) suggest.setAttribute("hidden", "");
        else suggest.removeAttribute("hidden");
      }
    }
    var timer = null, last = "";
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { render(""); return; }
      timer = setTimeout(function () {
        last = q;
        fetch(searchUrl + "/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,page&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (q !== last) return;
            var res = (d.resources && d.resources.results) || {};
            var prods = res.products || [];
            var pages = res.pages || [];
            var html = "";
            if (prods.length) {
              html += '<div class="sp-group">';
              prods.forEach(function (p) {
                html += '<a class="sp-item" href="' + p.url + '">'
                  + '<span class="sp-thumb">' + (p.image ? '<img src="' + thumb(p.image) + '" alt="" loading="lazy">' : "") + "</span>"
                  + '<span class="sp-info"><span class="sp-name">' + esc(p.title) + '</span><span class="sp-price">' + money(p.price) + "</span></span>"
                  + "</a>";
              });
              html += "</div>";
            }
            if (pages.length) {
              html += '<div class="sp-group"><p class="sp-label">Sider</p>';
              pages.forEach(function (pg) {
                html += '<a class="sp-page" href="' + pg.url + '">' + esc(pg.title) + "</a>";
              });
              html += "</div>";
            }
            if (!prods.length && !pages.length) {
              html = '<p class="sp-empty">Ingen resultater for &ldquo;' + esc(q) + '&rdquo;</p><a class="sp-all" href="/collections/vine">Se alle vine &rarr;</a>';
            } else {
              html += '<a class="sp-all" href="' + searchUrl + "?q=" + encodeURIComponent(q) + '">Se alle resultater &rarr;</a>';
            }
            render(html);
          })
          .catch(function () {});
      }, 250);
    });
  }
  function init() {
    initHeader();
    initReveal();
    initCart();
    initCountry();
    initProduct();
    initBuildCase();
    initSearch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Theme editor: re-init when a section is re-rendered */
  document.addEventListener("shopify:section:load", function (e) {
    initHeader();
    initReveal(e.target);
  });
})();
